export default __webpack_public_path__ + "static/media/fullbleed2.4a464e4c.jpg";